import { forwardRef } from 'react';

import CircularProgress from '@zenbusiness/zui/CircularProgress';

import * as Styled from './styles';

export const LoadingSpinner = forwardRef(function LoadingSpinner(props, ref) {
  return (
    <Styled.Spinner ref={ref}>
      <Styled.Progress
        // See https://stackoverflow.com/questions/38704467/how-to-label-a-loading-animation-for-wai-aria
        aria-busy="true"
        aria-live="polite"
        aria-valuemax="100"
        aria-valuemin="0"
        aria-valuetext="Loading..."
        role="progressbar"
        size={110}
        thickness={3}
        variant="indeterminate"
        {...props}
      />
      <Styled.Logo />
    </Styled.Spinner>
  );
});
LoadingSpinner.propTypes = CircularProgress.propTypes;
LoadingSpinner.displayName = 'LoadingSpinner';
